<template>
    <div>
        <!-- label="ID Document Type" -->
        <b-form-group label-for="documentType" class="required-field"
            ><label v-if="isUrdu" class="urdu-label" for=""
                >شناختی دستاویز کی قسم</label
            >
            <label v-else>ID Document Type</label>
            <b-form-select
                v-model="model"
                v-validate="{
                    required: true,
                }"
                class="form-control"
                :options="options"
                :disabled="loading || disabled"
                data-vv-name="document type"
                :class="{
                    'is-invalid': errors.has('document type'),
                }"
            >
                <option slot="first" :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>
<script>
import Dropdown from './Dropdown.vue'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: Dropdown, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    title: 'Select ID Document Type',
                    label: 'ID Document Type',
                    placeholder: 'Select ID Document Type',
                    options: [
                        {
                            text: 'National ID Card',
                            value: 'id',
                        },
                        {
                            text: 'National Identity Card for Overseas Pakistanis',
                            value: 'nicop',
                        },
                        // {
                        //     text: 'Passport',
                        //     value: 'passport',
                        // },
                        {
                            text: 'Pakistan Origin Card',
                            value: 'poc',
                        },
                        {
                            text: 'National Alien Registration System',
                            value: 'arc',
                        },
                    ],
                    key: 'identityInfo.type',
                }
            },
            required: false,
        },
        dataSegmentId: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: true,
        },
    }, // End of Component > watch

    computed: {
        ssaAccount() {
            if (this.dataSegmentId == process.env.VUE_APP_SSA_ACCOUNT)
                return true
        },
        isUrdu() {
            let lang = this.$store.getters.getField('languageOption')
            if (lang == 'urd') {
                return true
            }
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        this.options = this.field.options
    },
}
</script>
